<template>
  <section>
    <div class="m-subheader ">
      <div class="d-flex align-items-center">
        <div class="mr-auto">
          <h3 class="m-subheader__title m-subheader__title--separator">
            {{ 'user_administration' | titleize}}
          </h3>
          <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
          </ul>
        </div>
      </div>
    </div>
    <div class="m-content" id="content">
      <div class="m-portlet m-portlet--tab">
        <div class="m-portlet__head">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <span class="m-portlet__head-icon m--hide">
                <i class=""></i>
              </span>
              <h3 class="m-portlet__head-text">{{ 'assign_permissions' | capitalize }}</h3>
            </div>
          </div>
        </div>
        <div class="m-portlet__body">
          <table class="table m-table m-table--head-bg-brand table-striped">
            <thead>
              <tr>
                <th>
                  {{ 'code' | capitalize }}  
                </th>
                <th>
                  {{ 'name' | capitalize }}  
                </th>
                <th>
                  {{ 'description' | capitalize }}
                </th>
                <th>
                  {{ 'state' | capitalize }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="group in groups" :key="group.id">
                <th scope="row">
                  {{ group.code }}
                </th>
                <td>
                  {{ group.name | capitalize }}
                </td>
                <td>
                  {{ group.description | capitalize }}
                </td>
                <td>
                  <label class="m-checkbox m-checkbox--air m-checkbox--solid m-checkbox--state-brand">
                    <input type="checkbox" :name="`group-${group.id}`" :id="`group-${group.id}`" @click="updateGroup(group.id)">
                    <span></span>
                  </label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      groups: [],
      id: ''
    }
  },
  methods: {
    updateGroup (group) {
      const status = document.getElementById(`group-${group}`).checked
      this.$spinner.show()
      this.updateGroupPermissionProfile({ profile: this.id, group, state: (status) ? 1 : 0 })
        .then(() => {
          this.$spinner.remove()
          this.$toast('permission_status_message', 1)
        })
        .catch(() => {
          this.$spinner.remove()
          document.getElementById(`group-${group}`).checked = !status
          this.$toast('general_error', 4)
        })
    },
    ...mapActions(['retrieveActiveGroupPermissions', 'retrieveGroupPermissionsByProfile', 'updateGroupPermissionProfile'])
  },
  created () {
    this.$spinner.show()
    this.id = this.$route.params.id
    this.retrieveActiveGroupPermissions()
      .then((res) => {
        this.groups = res.data
        this.retrieveGroupPermissionsByProfile(this.id)
          .then((res) => {
            const groups = res.data
            groups.forEach((item, index) => {
              if (item.state === 1) {
                document.getElementById(`group-${item.permission_group_id}`).checked = true
              }
            })
            this.$spinner.remove()
          })
      })
  }
}
</script>

<style scoped>

.thead-inverse th {
  background: #1F2742!important;
}
.table th, .table td {
  text-align: center;
}

tbody {
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// AssignGroup.vue